import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "../../../../store";
import { makeArrayRandom } from "../../../../utils/learner";

export default function WebSelectOptionsColumn({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;

    const [answerBox, setAnswerBox] = useState(makeArrayRandom(data.answerBox));
    const [answer, setAnswer] = useState({});

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAnswerBox(makeArrayRandom(data.answerBox))
        setAnswer({});
    }, [question,
        data.answerBox
    ]);

    const handleChoiceClick = (option, key) => {
        let ans = {...answer};
        ans[key] = option.value;
        setAnswer(ans);

        let canProceed = false;
        const answerKeys = Object.keys(ans);
        answerKeys.map((key) => {
            if (ans[key] !== "" && ans[key] !== null) {
                canProceed = true;
            }
            return null;
        });
        
        onAnswer({
            canProceed,
            answer: ans,
        });
    }

    return (
        <Box
            sx={{
                width: "1000px",
                textAlign: "center"
            }}
        >
            {answerBox.map((ans, index) => (
                <Box key={index}
                    sx={{
                        display: "inline-flex",
                        width: "480px",
                        fontWeight: "bold",
                        justifyContent: "space-between",
                        marginRight: "5px",
                        padding: "10px",
                        backgroundColor: "rgb(255, 192, 0)",
                        borderBottom: "10px solid rgb(185, 138, 23)",
                        marginBottom: "5px",
                        alignItems: "center",
                        textAlign: "center",
                        fontSize: "20px",
                    }}
                >
                    <Box component="span">{ans.value}</Box>
                    <Box sx={{
                        display: "flex",
                        fontWeight: "bold",
                        textAlign: "center",
                    }}>
                        {ans.options.map((option, index) => (
                            <Box key={index} 
                                component="span"
                                sx={{
                                    width: "60px",
                                    height: "30px",
                                    borderBottomWidth: "5px",
                                    marginLeft: "5px",
                                    display: "inline-table",
                                    cursor: "pointer",
                                    userSelect: "none",
                                    backgroundColor: answer[ans.stateKey] === option.value ? "#afe23e" : "#dadada",
                                        borderBottom: answer[ans.stateKey] === option.value ? "10px solid #639729" : "10px solid #808080",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    fontSize: "20px",
                                }}
                                onClick={() => handleChoiceClick(option, ans.stateKey)}
                            >
                                <Box component="span"
                                    sx={{
                                        display: "table-cell",
                                        verticalAlign: "middle",
                                        cursor: "pointer",
                                        fontWeight: 'bold',
                                    }}
                                >{option.value}</Box>
                            </Box> 
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};